import React from "react";
import LogoBg from "../../img/logo.png";

const Logo = () => <img src={LogoBg} alt="logo" />;

export default Logo;